
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { type WideCardType } from '@xt/client/types/home.d'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import DayHeadCard from './card/dayHeadCard.vue'
import WideCard from './card/wideCard.vue'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    WideCard,
    DayHeadCard,
    NewSwiper
  }
})
export default class extends Vue {
  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  data: WideCardType[][] = []

  activeIndex: number = 0

  get dataSource() {
    return this.$store.$homeV2.dataSource?.activityCourse
  }

  handleChange(index) {
    this.activeIndex = index
  }

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  splitData() {
    this.data = lodash.chunk(this.dataSource?.list, 4)
  }

  created(): void {}

  mounted(): void {
    this.splitData()
  }

  updated(): void {}

  destroyed(): void {}
}
